import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { PoModalAction, PoModalComponent, PoModalModule, PoModule, PoSwitchLabelPosition, PoTagModule, PoWidgetModule } from '@po-ui/ng-components';
import { CardComponent } from '../card/card.component';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from '../../../shared/service/api.service';
import { ToasterService } from '../../../shared/service/toaster.service';
import { catchError, expand, of } from 'rxjs';
import { FormsModule } from '@angular/forms';
import { ScannerComponent } from '../../../shared/components/scanner/scanner.component';
import { ToasterComponent } from '../../../shared/components/toaster/toaster.component';
import { CONSTANTS } from '../../../constants';
import { PackService } from '../../../shared/service/pack.service';

@Component({
  selector: 'app-detail-pack',
  imports: [PoModule, PoWidgetModule, CommonModule, CardComponent, FormsModule, ScannerComponent, ToasterComponent, PoTagModule, PoModalModule],
  templateUrl: './detail-pack.component.html',
  styleUrls: ['./detail-pack.component.css']
})
export class DetailPackComponent implements OnInit, AfterViewInit {
  @ViewChild('poModalDuplicate', { static: false }) poModalDuplicate!: PoModalComponent;
  @ViewChild(ToasterComponent) toasterComponent!: ToasterComponent;

  activeRemoveItemTemp: PoModalAction = {
    action: () => {
      this.poModalDuplicate.close();
      this.removeItemPack();
      this.focusInputBarcode();
    },
    label: 'Sim',
    danger: true
  };
  cancelRemoveItemTemp: PoModalAction = {
    action: () => {
      this.poModalDuplicate.close();
      this.focusInputBarcode();
    },
    label: 'Não',
  };

  seeDescriptionPack: boolean = false;
  packNumber: number = 0;
  packDescription: string = '';
  packBarCode: string = '';
  itemPackBarCode: string = '';
  nullItemList: boolean = false;
  itemsPackList: any = [];
  switchRemove: boolean = false;
  labelPosition: PoSwitchLabelPosition = PoSwitchLabelPosition.Left;
  activedRemoveItem: boolean = false;
  statusLabels = CONSTANTS.QUANTITY_STATUS;
  colorsStatusLabels = CONSTANTS.QUANTITY_STATUS_COLORS;
  quantityOriginal: number = 0;
  quantityIncremented: number = 0;
  quantityRemoved: number = 0;
  quantityTotal: number = 0;
  startScanning: boolean = false;
  scannedCodes: any = [];
  changedSwitch: boolean = false;
  alertItemPack: string = '';
  useGrouping: boolean = true;
  seeDescriptionItemPack: boolean = false;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private api: ApiService,
    private packService: PackService,
    private toasterService: ToasterService
  ) { }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      this.packNumber = +params['packnumber'];
    });
    this.getPack();
  }

  ngAfterViewInit() {
    this.toasterComponent.alertClosed.subscribe(() => {
      this.focusInputBarcode();
    });
  }

  seeDescription() {
    this.seeDescriptionPack = !this.seeDescriptionPack;
  }

  getPack() {
    this.recoverPack().pipe(
      catchError((error) => {
        let errorMessage = '';
        if (error.error && Array.isArray(error.error) && error.error.length > 0) {
          errorMessage = error.error[0].message || 'Erro desconhecido.';
        } else if (error.message) {
          errorMessage = error.message;
        } else {
          errorMessage = 'Ocorreu uma falha ao buscar o pack.';
        }
        this.toasterService.triggerAlert(errorMessage, 'warning');
        return of(false);
      })
    ).subscribe((data: any) => {
      this.packDescription = data.packDescription;
      this.packBarCode = data.packBarCode;
      this.itemsPackList = data.items || [];
      this.quantityOriginal = (data.items || []).reduce((total: number, item: any) => total + item.quantity, 0);
      this.quantityTotal = this.quantityOriginal;
    });
  }

  recoverPack() {
    if (this.useGrouping) {
      return this.packService.getCapaPackGroup(this.packNumber, '');
    } else {
      return this.packService.getCapaPack(this.packNumber, '');
    }
  }

  activeRemoveItem() {
    this.activedRemoveItem = !this.activedRemoveItem;
    const input = document.querySelector('input.po-input[name="inputBarcode"]') as HTMLInputElement;
    if (input) {
      if (input.value) {
        input.value = '';
        this.changedSwitch = true;
      }
      input.focus();
    }
  }

  updateDetailPack(barcode: string) {
    if (barcode && !this.changedSwitch) {
      const scannedItem = {
        code: barcode,
        isRemove: this.switchRemove
      };

      this.scannedCodes.push(scannedItem);

      if (!this.startScanning) {
        this.startScanning = true;
        this.processScannedCodes();
      }

      this.focusInputBarcode();
    }
    this.changedSwitch = false;
  }

  includeItemPack() {
    this.recoverPackItem().pipe(
      catchError((error) => {
        let errorMessage = '';
        if (error.error[0].code == 'BarCodeRfidAlreadyExist') {
          this.alertItemPack = error.error[0].message;
          this.poModalDuplicate.open();
          return of(false);
        } else if (error.error && Array.isArray(error.error) && error.error.length > 0) {
          errorMessage = error.error[0].message || 'Erro desconhecido.';
        } else if (error.message) {
          errorMessage = error.message;
        } else {
          errorMessage = 'Ocorreu uma falha ao gerar o item do pack.';
        }
        this.toasterService.triggerAlert(errorMessage, 'warning');
        return of(false);
      })
    ).subscribe((data: any) => {
      if (data) {
        const existingItem = this.itemsPackList.find((item: any) => item.productCode === data.productCode);
        if (existingItem && this.useGrouping) {
          existingItem.productSkus.unshift({ productSku: data.productSku });
          existingItem.quantity += data.quantity;
        } else {
          const newItemPack = {
            packItemNumber: data.packItemNumber,
            packNumber: data.packNumber,
            productCode: data.productCode,
            productColor: data.productColor,
            productName: data.productName,
            productSku: data.productSku,
            quantity: data.quantity,
            productSkus: [{ productSku: data.productSku }],
            status: 1,
            expanded: this.useGrouping ? false : true,
          };
          this.itemsPackList.unshift(newItemPack);
        }

        this.quantityIncremented++;
        this.quantityTotal = this.quantityOriginal + this.quantityIncremented - this.quantityRemoved;
      }
    });
  }

  recoverPackItem() {
    return this.packService.postItemPack(this.packNumber, this.itemPackBarCode, 1);
  }

  removeItemPack() {
    this.packService.deleteItemPack(this.packNumber, this.itemPackBarCode).pipe(
      catchError((error) => {
        let errorMessage = '';
        if (error.error && Array.isArray(error.error) && error.error.length > 0) {
          errorMessage = error.error[0].message || 'Erro desconhecido.';
        } else if (error.message) {
          errorMessage = error.message;
        } else {
          errorMessage = 'Ocorreu uma falha ao remover o item do pack.';
        }
        this.toasterService.triggerAlert(errorMessage, 'warning');
        return of(false);
      })
    ).subscribe((response: any) => {
      if (response) {
        const itemToUpdate = this.itemsPackList.find((item: any) => item.productCode === response.productCode);
        if (itemToUpdate) {
          itemToUpdate.productSkus = itemToUpdate.productSkus.filter((skuCode: any) => skuCode.productSku !== response.productSku);
          itemToUpdate.quantity--;

          if (itemToUpdate.quantity === 0) {
            this.itemsPackList = this.itemsPackList.filter((item: any) => item.productCode !== response.productCode);
          }
        }
        this.quantityRemoved++;
        this.quantityTotal = this.quantityOriginal + this.quantityIncremented - this.quantityRemoved;
      }
    });
  }

  async processScannedCodes() {
    while (this.scannedCodes.length > 0) {
      const item = this.scannedCodes.shift();
      if (item) {
        this.itemPackBarCode = item.code;
        if (item.isRemove) {
          await this.removeItemPack();
        } else {
          await this.includeItemPack();
        }
      }
    }

    setTimeout(() => {
      this.startScanning = false;
    }, 200);
  }

  backPage = () => {
    this.router.navigate(['/pack']);
  }

  restore() {
    this.startScanning = false;
  }

  seeDescriptionItens() {
    this.seeDescriptionItemPack = !this.seeDescriptionItemPack;
  }

  private focusInputBarcode() {
    setTimeout(() => {
      const input = document.querySelector('input.po-input[name="inputBarcode"]') as HTMLInputElement;
      if (input) {
        input.focus();
      }
    }, 100);
  }
}
